import "./_bootstrap.scss";
import "./BasePage.scss";

import { SiteBase } from "@Base/Site/SiteBase";
import { Chat } from "@Tenants/Fun/Engagement/Chat/Chat";
import { Header } from "@Tenants/Fun/Site/Header";
import { SiteList } from "@Tenants/Fun/Site/SiteList";
import { TransitBanner } from "@Tenants/Fun/Site/TransitBanner";
import { Footer } from "@Tenants/Fun/Site/Footer";

export class BasePage extends SiteBase
{
	public Chat: Chat;
	public SiteList: SiteList;
	public Header: Header;
	public Footer: Footer;

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.SiteList = new SiteList();
		this.Chat = new Chat();
		this.Header = new Header();
		this.TransitBanner = new TransitBanner();
		this.Footer = new Footer();
	};
}